import React from 'react';

// Styles
import './Intro.css';

const cards = [
  {
    title: "Перші синтетичні волокна були створені у 1920-х роках",
    description: "Першим синтетичним волокном було нейлон, розроблене хіміком Воллесом Карсдомом. Воно стало відомим як матеріал для виробництва колготок та панчішних виробів"
  },

  {
    title: "Синтетичні волокна мають високу міцність",
    description: "Вони можуть бути набагато міцнішими за натуральні волокна, такі як бавовна або шовк. Це робить їх ідеальними для виробництва одягу та текстильних матеріалів, які потребують високої зносостійкості"
  },

  {
    title: "Синтетичні волокна швидко сохнуть",
    description: "Оскільки вони не поглинають вологу, як натуральні волокна, синтетичні текстильні матеріали швидко висихають після прання або забруднення"
  },

  {
    title: "Вони можуть бути водовідштовхувальними",
    description: "Багато синтетичних волокон мають природну водовідштовхувальну властивість. Це означає, що вони не поглинають вологу і швидко відштовхують воду. Це корисно для одягу, який має бути захищений від дощу або пляжного одягу, який швидко сохне на сонці"
  },

  {
    title: "Синтетичні волокна можуть бути стійкими до зносу",
    description: "Багато синтетичних волокон, таких як поліестер або нейлон, відмінно переносять часте прання і зберігають свою форму та колір після багатьох прань"
  }
];

const Intro = () => {
  return (
    <section className='intro' id='intro'>
      <h1 className="intro__title">Про <span>синтетичні волокна</span></h1>

      {/* Cards wrap */}
      <div className="intro__cards">
        {cards.map((card, index) => (
          <div className="intro__cards__card" key={index}>
            <div className="intro__cards__card__icon">
            </div>
            <h2 className="intro__cards__card__title">{card.title}</h2>
            <p className="intro__cards__card__description">{card.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Intro;
